import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrl: './home.component.css'
})
export class HomeComponent {
  constructor(private readonly router: Router) { }
  
  navigateToIntegrationGuide() {
    this.router.navigate(['/integration-guide']);
  }
}
